import axios from "axios";

export function deletePromotion(data) {
  var config = {
    method: "delete",
    url: `${process.env.VUE_APP_APIHOST}/eaa/shops/${data.businessId}/promotions/${data.id}`,
  };
  return axios(config);
}
